<!-- eslint-disable-next-line agentic/no-single-template-wrapper -->
<div
    class="qpx-filter-group @container"
    [class.open]="menuOpen()"
    qpxClickOutside
    (clickOutside)="closeMenu()"
>
    <div [class]="`icon-container hidden ${iconClasses()}`">
        <ng-icon qpx size="sm" name="lucideSlidersHorizontal" />
    </div>

    <button
        [class]="`menu-trigger flex ${menuTriggerClasses()}`"
        qpxButton
        matButton="elevated"
        (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen()"
        aria-haspopup="true"
        [matBadge]="activeCount() || undefined"
    >
        <ng-icon
            qpx
            context="primary"
            name="lucideSlidersHorizontal"
            matButtonIcon
        />
        <span>{{ triggerLabel() }}</span>
        <ng-icon
            qpx
            size="sm"
            class="chevron"
            name="lucideChevronDown"
            matButtonIcon
            iconPositionEnd
        />
    </button>

    <div
        [class]="`menu-open ${menuOpen() ? 'flex' : 'hidden'} ${filterListClasses()}`"
        role="group"
        aria-label="Filter options"
        #container
    >
        <ng-content />
    </div>
</div>
